var baseUrl = 'https://jsonplaceholder.typicode.com/';

const configVariables = {
  baseUrl,
};

const constantVariables = {
  TempUser: { name: 'David Smith', email: 'david@yopmail.com', pass: 'asd123', userId: 12 },
};

const Variables = {
  ...configVariables,
  ...constantVariables,
};

export default Variables;
